<div *ngIf="question.questionCategory != 'CUSTOM'">
  <div class="question-section">
    <p class="question-text">
      {{question.description | translate}}
    </p>
  </div>

  <div *ngIf="question.questionCategory !== 'AI'" class="answer-section">
    <p><i>{{'pre-interview-questions.answer-options' | translate}}</i></p>

    <div *ngIf="question.questionTypeId === QuestionType.YES_NO">
      <p class="answer-option">{{'pre-interview-questions.answer-option-yes' | translate}}</p>
      <p class="answer-option">{{'pre-interview-questions.answer-option-no' | translate}}</p>
    </div>

    <p class="answer-option" *ngFor="let answerOption of question.optionChoiceList">
      {{answerOption.description}}
    </p>
  </div>
</div>

<div *ngIf="question.questionCategory === 'CUSTOM' && (pageState === 'edit' || question.selected === true)">
  <div class="question-section">
    <input type="text" class="custom-question-input"
           placeholder="Enter a custom question"
           [(ngModel)]="_value"
           (change)="propagateText($event)"
           *ngIf="pageState === 'edit'"
           [disabled]="!question.selected"
           (keyup)="onKey($event)">
    <p class="question-text" *ngIf="pageState === 'view'">{{question.description}}</p>
  </div>
  <br>
</div>
